//not being used !!!!!!
// Wait for the document to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Check if the language is Arabic (RTL)
  if (document.documentElement.lang === "ar") {
    // Find the previous and next pagination icons
    var prevIcon = document.querySelector(".pagination__item--prev .icon");
    var nextIcon = document.querySelector(".pagination__item--next .icon");

    // Flip the previous icon (rotate 90 degrees for RTL)
    if (prevIcon) {
      prevIcon.style.transform = "rotate(90deg)";
      prevIcon.style.marginLeft = "-.2rem"; // Adjust margin for RTL
    }

    // Flip the next icon (rotate -90 degrees for RTL)
    if (nextIcon) {
      nextIcon.style.transform = "rotate(-90deg)";
      nextIcon.style.marginRight = "-.2rem"; // Adjust margin for RTL
    }
  } else {
    // For LTR (default), reset to original rotation
    var prevIcon = document.querySelector(".pagination__item--prev .icon");
    var nextIcon = document.querySelector(".pagination__item--next .icon");

    if (prevIcon) {
      prevIcon.style.transform = "rotate(-90deg)";
      prevIcon.style.marginRight = "-.2rem"; // Adjust margin for LTR
    }

    if (nextIcon) {
      nextIcon.style.transform = "rotate(90deg)";
      nextIcon.style.marginLeft = "-.2rem"; // Adjust margin for LTR
    }
  }
});
